import * as API_CONSTANT from "../constants";

export const getAllLoyalty = () =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/loyalty/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({}),
  }).then((res) => res.json());